import React, { useState } from 'react';
import ActionButton from '../../ActionButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { Colors } from 'library';
import client from 'shared/ApiClient';
import JobSelection from './JobSelection';
import { JobModel } from '../../../NewsfeedModels';

export default function ShareJobAction({ setJob }: { setJob: (x: JobModel) => void }) {
    const [showJobSelection, setShowJobSelection] = useState(false);

    const onCloseDialog = () => {
        setShowJobSelection(false);
    };

    const handleJobSelection = (job: any) => {
        client('api/get-job-details/?id=' + job.id).then((response) => {
            setJob(response);
        });
    };

    return (
        <div>
            <ActionButton
                icon={() => (
                    <FontAwesomeIcon
                        icon={faBriefcase}
                        color={Colors.darkNavy}
                        size={'sm'}
                        onClick={() => setShowJobSelection(true)}
                    />
                )}
            />
            <JobSelection
                open={showJobSelection}
                onClose={onCloseDialog}
                selectJob={(e: any) => handleJobSelection(e)}
            />
        </div>
    );
}
